import React, { useState, useEffect } from 'react';
import EducationCard from 'components/Cards/EducationCard';
import ToggleDetail from 'components/ToggleDetail';
import EducationFormWrapper from 'components/Forms/EducationFormWrapper';
import { get } from 'services';
import { connect } from 'react-redux';
import Alerts from 'utils/alerts' 
import Spinner from 'react-bootstrap/Spinner'
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const EducationModule = ({user, history}) => {
  
  const [isLoading, setIsLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true)
        const response = await get(`PersonaEducacion/GetByPersonaId/${user.persona.id}`);
        if (response && response.data.length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }
        setData(response.data);
      } catch (error) {
        Alerts.operationFail()
      } finally {
        setIsLoading(false)
      }
    })();
  }, [])
  
  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                animation="grow" 
                variant="primary" 
                className={'is-absolute center-spinner-vertically'} 
                size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail} onToggleDetail={setShowDetail} label="Educación"/>
        { 
          showDetail ? 
          <div> 
            <EducationCard data={data}/>
            <br/>
            <Navigation beforeUrl={user.esEmpleado ? "/vehicle" : "/"} continueUrl="/language" />
          </div>
          : 
          <div> 
            <EducationFormWrapper data={data} />
          </div>
        }
      </div>
    </>
    
  )
};

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}
export default connect(mapStateToProps)(EducationModule);